import { Button, Col, Row, Tabs } from 'antd'
import ButtonGroup from 'antd/lib/button/button-group'
import TabPane from 'antd/lib/tabs/TabPane'
import { useEffect } from 'react'
import { MEASUREMENT_TYPE_IMAGE_BASE_URL } from '../../../../../config/constant'
import { MeasurementDataChart } from './components/MeasurementDataChart'
import { MeasurementDataTable } from './components/MeasurementDataTable'

export const MeasurementDataModal = (props) => {
    useEffect(() => {
        // console.log(props);
        // console.log(props.measurementRecordedData);
        handleFilter(props?.measurementType, props?.measurementData?.id)

        // handleFilter(props?.measurementRecordedData)
    }, [props.measurementRecordedData])

    const handleFilter = (targetUnitName, measurement_type_id) => {
        if (props?.measurementRecordedData) {
            // Get all records for this measurement type (ignore unit for now)
            const typeRecords = props.measurementRecordedData.filter(
                (element) => element.measurement_type_id == measurement_type_id
            )

            // Normalize all records to the target unit
            const targetUnitRecord =
                props.measurementData.measurements_type_unit.find(
                    (u) => u.unit.name === targetUnitName
                )

            const normalizedData = typeRecords.map((record) => {
                if (record.measurement_unit === targetUnitName) {
                    return record // Already in target unit
                }

                // If not in target unit, find the formula to convert TO target unit
                // Our logic: NewValue = OldValue * TargetFormula
                if (targetUnitRecord && targetUnitRecord.formula) {
                    let convVal =
                        parseFloat(record.value) *
                        parseFloat(targetUnitRecord.formula)

                    // Snap to integer if close
                    if (Math.abs(convVal - Math.round(convVal)) < 0.01) {
                        convVal = Math.round(convVal)
                    }

                    return {
                        ...record,
                        value: convVal.toFixed(2),
                        measurement_unit: targetUnitName,
                    }
                }
                return record
            })

            props.setFilteredData(normalizedData)
        }
    }

    const data = [
        // {
        //     id: '1001',
        //     date: '31 Aug, 2022',
        //     time: "05:30:00",
        //     value: 72.0,
        //     unitType: {
        //         id: 1,
        //         name: "cm"
        //     }
        // },
        // {
        //     id: '1002',
        //     date: '1 Aug, 2022',
        //     time: "15:46:11",
        //     value: 80.4,
        //     unitType: {
        //         id: 2,
        //         name: "in"
        //     }
        // },
        // {
        //     id: '1003',
        //     date: '02 Sep, 2022',
        //     time: "17:44:42",
        //     value: 71.4,
        //     unitType: {
        //         id: 3,
        //         name: "cm"
        //     }
        // },
        // {
        //     id: '1004',
        //     date: '3 Aug, 2022',
        //     time: "15:46:11",
        //     value: 55.4,
        //     unitType: {
        //         id: 4,
        //         name: "in"
        //     }
        // },
        // {
        //     id: '1005',
        //     date: '1 Aug, 2022',
        //     time: "05:30:00",
        //     value: 72.0,
        //     unitType: {
        //         id: 1,
        //         name: "mg/dL"
        //     }
        // },
        // {
        //     id: '1006',
        //     date: '1 Aug, 2022',
        //     time: "05:30:00",
        //     value: 72.0,
        //     unitType: {
        //         id: 1,
        //         name: "mmHg"
        //     }
        // },
    ]

    return (
        <>
            <Row>
                <Col
                    xl={24}
                    className="text-center d-flex justify-content-center align-self-center align-items-center "
                >
                    {/* <div className="d-flex justify-content-center align-self-center"> */}

                    <img
                        src={
                            MEASUREMENT_TYPE_IMAGE_BASE_URL +
                            props.measurementData.image
                        }
                        alt="Weight"
                        width={50}
                    />
                    <p className="mb-0 ms-2 h5">{props.measurementData.name}</p>
                    {/* </div> */}
                </Col>
                <hr />

                <Col span={24}>
                    <ButtonGroup className="align-self-center float-end">
                        {props.measurementData.measurements_type_unit.map(
                            (element, index) => (
                                <Button
                                    key={index}
                                    disabled={
                                        props.measurementData
                                            .measurements_type_unit.length == 1
                                    }
                                    onClick={() => {
                                        handleFilter(
                                            element.unit.name,
                                            props?.measurementData?.id
                                        )
                                        props.handleUnit(element)
                                    }}
                                    style={{
                                        background:
                                            props.measurementType ==
                                            element.unit.name
                                                ? '#5F4B8BFF'
                                                : '',
                                        color:
                                            props.measurementType ==
                                            element.unit.name
                                                ? '#FFFFFF'
                                                : '',
                                    }}
                                    className="align-self-center"
                                    value={element.unit.name}
                                >
                                    {element.unit.name}
                                </Button>
                            )
                        )}
                    </ButtonGroup>
                </Col>
                <Col span={24}>
                    <div className="patient-master">
                        <Tabs
                            defaultActiveKey="1"
                            // onChange={onChange}
                            type="card"
                            tabPosition="top"
                        >
                            <TabPane tab="Table" key="1">
                                <MeasurementDataTable
                                    data={
                                        props.filteredData && props.filteredData
                                    }
                                />
                                {/* <MeasurementDataTable data={filteredData} /> */}
                            </TabPane>
                            <TabPane tab="Graph" key="2">
                                <MeasurementDataChart
                                    data={
                                        props.filteredData && props.filteredData
                                    }
                                />
                            </TabPane>
                        </Tabs>
                    </div>
                </Col>
            </Row>
        </>
    )
}
